import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { impressionUrl: String }

  connect() {
    if (!this.hasImpressionUrlValue) return

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) {
        this.trackImpression()
        this.observer?.disconnect()
      }
    }, { threshold: 0.5 })

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  trackImpression() {
    if (this.tracked) return
    this.tracked = true

    const token = document.querySelector("meta[name='csrf-token']")?.content || ""
    const body = new URLSearchParams({
      authenticity_token: token,
      page_path: `${window.location.pathname}${window.location.search}`
    })

    fetch(this.impressionUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: body.toString(),
      keepalive: true
    }).catch(() => {})
  }
}
